<template>
	<div>
		<h1 class="view-title">
			LOGS <span v-popover:tooltip.right="'Seção de gerenciamento dos arquivos de Logs'"><i class="fas fa-question-circle"></i></span>
		</h1>
		<div class="inner-content shadowed">
			<div class="inner-content-title">Lista <span v-popover:tooltip.right="'Lista dos arquivos de logs'"><i class="fas fa-question-circle"></i></span></div>
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<div class="search">
                        <label>Filtro <span v-popover:tooltip.right="'Informe uma palavra-chave para identificação do registro desejado'"><i class="fas fa-question-circle"></i></span>:</label>
                        <input type="text" v-model="search" @keydown.enter.prevent="load(true)" /> 
                    </div>
					<Table 
                        :loading="loading"
                        :headers="headers" 
                        :ordering="ordering" 
                        :order="order"
                        @reorder="(o) => { order = o; load(); }"
                        :list="list" 
                        :modifiers="modifiers" 
                        :page="page"
                        :per_page="per_page" 
                        :total="total" 
                        @next="() => { page++; load(); }" 
                        @prev="() => { page--; load(); }"
                        v-slot="{item}"
                    >
						<button class="button-edit" @click="showModalLog(item)" title="Visualizar log">
							<i class="fa fa-fw fa-eye"></i>
						</button>
					</Table>
				</div>
			</div>
		</div>

		<AdminModalLog v-if="show_modal_log"
			:current="current"
			@close="closeModalLog"
		/>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Table from "@/components/Table";
import AdminModalLog from './AdminLog/AdminModalLog.vue';

export default {
	name: "AdminLog",

	components: {
		Table,
		AdminModalLog,
	},

	data: function() {
		return {
			search: "",

			loading: true,
			headers: {
				id: "#",
				filename: "Arquivo",
				type: "Ambiente",
				created_at: "Cadastro"
			},
			ordering: ["id"],
            order: 'id-DESC',
			list: [],
			page: 0,
			per_page: 25,
			total: 0,
			modifiers: {
				id: function(d) {
					return `<span title="${d}">${d}</span>`;
				},
				filename: function(d) {
					return `<span title="${d}">${d.toLowerCase()}</span>`;
				},
			},

			current: null,
			show_modal_log: false,
		};
	},

	mounted: async function() {
		await this.load();
	},

	methods: {
		/**
		 * Carrega a lista
		 * @param {boolean} is_search informa se o carregamento deriva de um filtro
		 */
		load: async function(is_search) {
			let form = {};

			if (this.search) form.search = this.search;
			if (is_search) this.page = 0;
			
			form.page = this.page;
			form.per_page = this.per_page;

			if (this.order) form.order = this.order;

			let result = null;
			this.list = [];
			this.total = 0;

			this.loading = true;
			try {
				result = await Api.post("log/list", form, "admin");
			} catch (ex) {
				console.log(ex);
				this.loading = false;
				this.$notification.error("Não foi possível obter a lista de arquivos de log.");
				return;
			}
			this.loading = false;

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout("admin");
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.list = result.data;
					this.total = result.total;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter a lista.");
				return;
			}
		},

		showModalLog: function(item) {
			this.current = item;
            this.show_modal_log = true;
		},

		closeModalLog: function() {
			this.show_modal_log = false;
			this.current = null;
		}
	}
}
</script>

<style scoped>
.details-label {
	width: 100%;
	font-weight: bold;
	padding: 10px;
}

.details-value {
	width: 100%;
	padding: 10px;
	font-size: 14px;
	color: #999;
}

hr {
	border: none;
	background: none;
	border-top: 1px solid #ddd;
}

.customer-filter-wrapper {
	position: relative;
	float: right;
	width: 200px;
	height: 30px;
	margin-top: 15px;
	color: #999;
}

.customer-filter-wrapper > i {
	position: absolute;
	top: 7px;
	left: 7px;
}

.customer-filter-input {
	position: absolute;
	width: 100%;
	height: 30px;
	padding-left: 30px;
	border-radius: 4px;
	border: 1px solid #ccc;
}

.btn-customer {
	float: right;
	margin-top: 10px;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.search {
	background: #fff;
	padding: 15px;
	border-top: 1px solid #f0f0f0;
	border-bottom: 1px solid #f0f0f0;
}

.search > label {
	font-weight: bold;
	font-size: 12px;
}

.search > input {
	width: 140px;
	margin-left: 15px;
}
</style>